import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../Shared/LoadingSpinner";

const EditStudentData = () => {
  const { id } = useParams();
  const imageStorageKey = "e13c0deb95648d59c098b58894a2f7c7";
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { data: student, isLoading } = useQuery(["student"], () =>
    fetch(`https://evaluation-server.onrender.com/getSingleStudent/${id}`).then((res) =>
      res.json()
    )
  );

  const onSubmit = (data) => {
    const image = data.image[0];
    const formData = new FormData();
    formData.append("image", image);
    const url = `https://api.imgbb.com/1/upload?key=${imageStorageKey}`;
    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          const dataValue = {
            firstName: data.fName,
            middleName: data.mName,
            lastName: data.lName,
            classValue: data.class,
            division: data.division,
            roll: data.roll,
            address1: data.address1,
            address2: data.address2,
            landmark: data.landmark,
            city: data.city,
            pin: data.pin,
            image: result.data.display_url,
          };
          fetch(`https://evaluation-server.onrender.com/editStudent/${student._id}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataValue),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.acknowledged) {
                toast.success("Student info edit successfully");
              }
            });
        }
      });
  };

  if (isLoading) {
    return <LoadingSpinner></LoadingSpinner>;
  }
  return (
    <div>
      <div>
        <p className="font-bold mb-4">Add student</p>
      </div>
      <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 pb-16">
          <div>
            <input
              defaultValue={student.firstName}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
              {...register("fName", {
                required: {
                  value: true,
                  message: "First Name is required",
                },
              })}
            />
            <label>
              {errors.fName?.type === "required" && (
                <span className="label-text-alt text-red-500">
                  {errors.fName.message}
                </span>
              )}
            </label>
          </div>

          <input
            placeholder="Middle name"
            defaultValue={student.middleName}
            className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
            {...register("mName")}
          />

          <div>
            <input
              defaultValue={student.lastName}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
              {...register("lName", {
                required: {
                  value: true,
                  message: "Last name is required",
                },
              })}
            />
            <label>
              {errors.lName?.type === "required" && (
                <span className="label-text-alt text-red-500">
                  {errors.lName.message}
                </span>
              )}
            </label>
          </div>

          <select
            className="border-2 border-indigo-500 w-full rounded-md px-2"
            {...register("class")}
          >
            <option defaultValue={student.classValue}>
              {student.classValue}
            </option>
            <option value="01">01</option>
            <option value="02">02</option>
            <option value="03">03</option>
            <option value="04">04</option>
            <option value="05">05</option>
            <option value="06">06</option>
            <option value="07">07</option>
            <option value="08">08</option>
            <option value="09">09</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>

          <select
            className="border-2 border-indigo-500 w-full rounded-md px-2"
            {...register("division")}
          >
            <option defaultValue={student.division}>{student.division}</option>
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
            <option value="D">D</option>
            <option value="E">E</option>
          </select>

          <div>
            <input
              defaultValue={student.roll}
              type="number"
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
              {...register("roll", {
                required: {
                  value: true,
                  message: "Password is required",
                },
                maxLength: {
                  value: 2,
                  message: "Roll must have 2 Digit only",
                },
              })}
            />
            <label className="label">
              {errors.roll?.type === "required" && (
                <span className="label-text-alt text-red-500">
                  {errors.roll.message}
                </span>
              )}
              {errors.roll?.type === "maxLength" && (
                <span className="label-text-alt text-red-500">
                  {errors.roll.message}
                </span>
              )}
            </label>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pb-5">
          <div>
            <input
              defaultValue={student.address1}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
              {...register("address1", {
                required: {
                  value: true,
                  message: "Address is required",
                },
              })}
            />
            <label>
              {errors.address1?.type === "required" && (
                <span className="label-text-alt text-red-500">
                  {errors.address1.message}
                </span>
              )}
            </label>
          </div>

          <input
            placeholder="Address line 2"
            defaultValue={student.address2}
            className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
            {...register("address2")}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          <div>
            <input
              defaultValue={student.landmark}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
              {...register("landmark", {
                required: {
                  value: true,
                  message: "Landmark is required",
                },
              })}
            />
            <label>
              {errors.landmark?.type === "required" && (
                <span className="label-text-alt text-red-500">
                  {errors.landmark.message}
                </span>
              )}
            </label>
          </div>

          <div>
            <input
              defaultValue={student.city}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
              {...register("city", {
                required: {
                  value: true,
                  message: "City is required",
                },
              })}
            />
            <label>
              {errors.city?.type === "required" && (
                <span className="label-text-alt text-red-500">
                  {errors.city.message}
                </span>
              )}
            </label>
          </div>

          <div>
            <input
              type="number"
              defaultValue={student.pin}
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
              {...register("pin", {
                required: {
                  value: true,
                  message: "Pin is required",
                },
                maxLength: {
                  value: 6,
                  message: "Pin code only use 6 digit highest",
                },
              })}
            />
            <label>
              {errors.pin?.type === "required" && (
                <span className="label-text-alt text-red-500">
                  {errors.pin.message}
                </span>
              )}
              {errors.pin?.type === "maxLength" && (
                <span className="label-text-alt text-red-500">
                  {errors.pin.message}
                </span>
              )}
            </label>
          </div>

          <div>
            <input
              type="file"
              className="border-2 border-indigo-500 w-full rounded-md py-3 px-2"
              {...register("image", {
                required: {
                  value: true,
                  message: "Image is required",
                },
              })}
            />

            <label>
              {errors.image?.type === "required" && (
                <span className="label-text-alt text-red-500">
                  {errors.image.message}
                </span>
              )}
            </label>
          </div>
        </div>
        <input
          value="Add Student"
          className="font-bold max-w-xs rounded-md my-4 py-3 px-3 text-white bg-indigo-500"
          type="submit"
        />
      </form>
    </div>
  );
};

export default EditStudentData;
